module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    ref: "time",
    staticClass: "semi-bold text-xs-center",
    attrs: {
      "id": "time-tooltip"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.tooltipTime) + "\n    ")]), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "grey lighten-2 ma-0 pa-0",
    attrs: {
      "buffer-value": _vm.bufferValue,
      "buffer": "",
      "primary": "",
      "id": "progress-bar",
      "height": "10"
    },
    on: {
      "click": _vm.onClick,
      "mousemove": function($event) {
        _vm.showTime($event)
      },
      "mouseout": function($event) {
        _vm.hideTime($event)
      }
    },
    model: {
      value: (_vm.buffer),
      callback: function($$v) {
        _vm.buffer = $$v
      },
      expression: "buffer"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05c627bb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThePlayer/ThePlayerProgressBar.vue
// module id = 339
// module chunks = 0